$(function () {

    var definedLang = document.documentElement.lang;

    if (typeof moment !== 'undefined') {
        moment.locale(definedLang);
    }

    $("body").tooltip({
        selector: '[data-toggle="tooltip"]',
        delay: 400
    });

    var menu = {
        recalculate: function () {
            var sideMenu = $('.sidebar-nav .side-menu');
            var bottomMargin = $(window).scrollTop() + $(window).height() - $('#wrapper').height();
            if (bottomMargin < 0) {
                bottomMargin = 0;
            }

            if ($(window).width() >= 768) {
                var scroll = $(window).scrollTop();

                sideMenu.css('position', 'fixed');
                var newPositionSideMenu = 0;
                if (sideMenu.outerHeight() < $(window).height()) {
                    if (scroll < 0) {
                        newPositionSideMenu = -scroll;
                    } else if (bottomMargin + sideMenu.outerHeight() > $(window).height()) {
                        newPositionSideMenu = $(window).height() - sideMenu.outerHeight() - bottomMargin;
                    }
                } else {
                    if (sideMenu.outerHeight() - scroll < $(window).height()) {
                        newPositionSideMenu = $(window).height() - sideMenu.outerHeight() - bottomMargin;
                    } else {
                        newPositionSideMenu = -scroll;
                    }
                }
                sideMenu.css('top', newPositionSideMenu);
            } else {
                sideMenu.css('position', 'relative');
                sideMenu.css('top', 0);
            }
        },
        init: function () {
            var win = this;
            $(window).on('load resize scroll', function () {
                win.recalculate();
            });
        }
    };

    $('#side-menu').metisMenu().on('shown.metisMenu', function (event) {
        $(window).trigger('resize');
    }).on('hidden.metisMenu', function (event) {
        $(window).trigger('resize');
    });

    $('[data-toggle="tooltip"]').tooltip({
        delay: {"show": 500, "hide": 100},
        html: true
    });

    $(document).on('click', 'button.row-delete', function (e) {
        e.preventDefault();
        var action = $(this).parents('tr,li,.panel-box,.data-delete').data('delete-action');
        var name = $(this).parents('tr,li,.panel-box,.data-delete').data('name');
        var subject = $(this).parents('tr,li,.panel-box,.data-delete').data('subject');
        var del = $('#delete');

        if (subject) {
            del.find('.subject').text(subject);
        }

        del.data('delete-action', action).modal('show');
        del.find('.name').text(name);
    });

    $(document).on('click', 'a.order-cancel', function (e) {
        e.preventDefault();

        $('#cancel').modal('show');
    });

    $(document).on('click', 'a.order-accept', function (e) {
        e.preventDefault();

        $('#accept').modal('show');
    });

    $('#switch-user-link').on('click', function (e) {
        e.preventDefault();
        $('#switch-user-modal').modal('show');
    });

    $('#_switch_user').on('changed.bs.select', function () {
        $(this).parents('form').submit();
    });

    $('#row-delete-perform').click(function () {
        location.href = $('#delete').data('delete-action');
        return false;
    });

    $('#order-cancel-perform').click(function () {
        location.href = $('#cancel').data('cancel-action');
        return false;
    });

    $('.alert-dismissible').delay(5000).animate({
        'opacity': 0,
        'height': 0,
        'padding-top': 0,
        'padding-bottom': 0,
        'margin-top': 0,
        'margin-bottom': 0
    }, 600, function () {
        $(this).hide();
    });

    $('.pagination input[data-action]').on('keyup', function (event) {
        if (event.keyCode === 13) {
            var url = $(this).data('link');
            var page = parseInt($(this).val());
            if (!isNaN(page)) {
                location.href = url.replace('/0', '/' + page);
            }

            $(this).effect("highlight", {color: '#ebcccc'})
        }
    });

    $(document).on('keyup', '.examination-result-box input[type=text]', function (e) {
        let from = parseFloat($(this).data('from').replace(',', '.'));
        let to = parseFloat($(this).data('to').replace(',', '.'));
        let range = to - from;
        let value = parseFloat($(this).val().replace(',', '.'));
        let badge = $(this).parents('.examination-result-box').find('.badge');
        let marker = $(this).parents('.examination-result-box').find('.range .marker');

        $(badge).stop().fadeOut(100, function () {
            $(this).addClass('hidden');
        });

        if (value <= ((range / 6) + from)) {
            $(badge).removeClass('hidden');
            $(badge).stop().fadeIn(100);

            if (value <= (from - (range / 6))) {
                $(badge).html('LL');
            } else if (value <= from) {
                $(badge).html('L');
            } else {
                $(badge).html('NL');
            }
        }

        if (value >= (((range / 6) * 5) + from)) {
            $(badge).removeClass('hidden');
            $(badge).stop().fadeIn(100);

            if (value >= ((range / 6) + to)) {
                $(badge).html('HH');
            } else if (value >= to) {
                $(badge).html('H');
            } else {
                $(badge).html('NH');
            }
        }

        if ($(this).val() === '') {
            $(marker).stop().fadeOut(200, function () {
                $(this).addClass('hidden');
            });
        } else {
            $(marker).removeClass('hidden');
            $(marker).stop().fadeIn(200);
        }

        let a = 60 / (to - from);
        let b = -a * from + 20;
        let y = a * value + b;
        $(marker).css('left', 'min(calc(100% - 8px), max(0%, calc(' + y + '% - 4px))');
    });

    $(window).bind("load resize", function () {

        $('.examination-result-box input[type=text]').keyup();

        var navbarCollapse = $('div.navbar-collapse');
        var heightOffset = $('nav.navbar').height();
        var width = (this.window.innerWidth > 0) ? this.window.innerWidth : this.screen.width;
        if (width < 769) {
            $(navbarCollapse).addClass('collapse');
        } else {
            $(navbarCollapse).removeClass('collapse');
        }

        var height = ((this.window.innerHeight > 0) ? this.window.innerHeight : this.screen.height) - 1 - heightOffset;
        var currentHeight = parseInt($("#page-wrapper").css("min-height"));
        var sidebarHeight = $('.sidebar').height() - heightOffset;
        var menuHeight = $('#side-menu').height();

        var conntentHeight = Math.max(currentHeight, sidebarHeight, menuHeight);

        if (height > conntentHeight) {
            $("#page-wrapper").css("min-height", (height) + "px");
            $(".page-content").css("min-height", (height) + "px");
        } else {
            $("#page-wrapper").css("min-height", (conntentHeight) + "px");
            $(".page-content").css("min-height", (conntentHeight) + "px");
        }

        menu.init();
    });

    if (typeof $.fn.nestedSortable !== 'undefined') {
        if ($('.getlabtest-sortable-tree').length) {
            $('.getlabtest-sortable-tree > ol').nestedSortable({
                handle: '.move',
                items: 'li',
                toleranceElement: '> .move',
                maxLevels: 3,
                opacity: .6,
                revert: 250,
                tabSize: 25,
                tolerance: 'pointer',
                forcePlaceholderSize: true,
                placeholder: 'placeholder',
                relocate: function () {
                    $.ajax({
                        url: "/api/menu/order",
                        method: 'PATCH',
                        dataType: 'json',
                        data: {
                            'tree': JSON.stringify($('.getlabtest-sortable-tree > ol').nestedSortable('toArray', {
                                startDepthCount: 0,
                                excludeRoot: 1
                            }))
                        },
                        success: function (response) {
                            if (!response.status) {
                                $.notification('error', 'Błąd zapisu.');
                            }
                        }
                    });
                }
            });
        }
    }

    $(document).on('change', '.btn-file :file', function () {
        var input = $(this),
            numFiles = input.get(0).files ? input.get(0).files.length : 1,
            label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
        input.trigger('fileselect', [numFiles, label]);
    });

    $(document).ready(function () {
        $('.btn-file :file').on('fileselect', function (event, numFiles, label) {

            var input = $(this).parents('.input-group').find(':text'),
                log = numFiles > 1 ? numFiles + ' files selected' : label;

            if (input.length) {
                input.val(log);
            } else {
                if (log) alert(log);
            }

        });
    });

    if (jQuery().datetimepicker) {
        jQuery.fn.extend({
            dateTimePickerBind: function (handler) {
                $(handler).find('.datetime-picker').datetimepicker({
                    format: 'DD.MM.YYYY HH:mm',
                    locale: definedLang
                });

                $(handler).find('.date-picker').datetimepicker({
                    format: 'L',
                    locale: definedLang
                });

                $(handler).find('.date-month-picker').datetimepicker({
                    viewMode: 'months',
                    format: 'MM.YYYY',
                    locale: definedLang
                });

                $(handler).find('.date-time-picker').datetimepicker({
                    format: 'HH:mm',
                    locale: definedLang
                });
            }
        });

        $(document).dateTimePickerBind(document);
    }

    if (jQuery().selectpicker) {
        jQuery.fn.extend({
            selectBind: function (root) {

                root.find('.form-group select').each(function () {

                    var select = $(this);

                    var selectpicker = select.selectpicker({
                        size: 10,
                        width: '100%',
                        noneResultsText: $.i18n('Nic nie znaleziono')
                    });

                    if (select.attr('data-ajax')) {
                        selectpicker.ajaxSelectPicker({
                            ajax: {
                                url: select.data('ajax'),
                                method: 'GET',
                                dataType: 'json',
                                data: function () {
                                    return {
                                        query: '{{{q}}}'
                                    };
                                }
                            },
                            preprocessData: function (data) {
                                var rows = [];
                                for (var i = 0; i < data.length; i++) {
                                    rows.push({
                                        'value': data[i].id,
                                        'text': data[i].name,
                                    });
                                }
                                return rows;
                            },
                            locale: {
                                currentlySelected: $.i18n('Wybrany'),
                                emptyTitle: '-- ' + $.i18n('wybierz') + ' --',
                                errorText: $.i18n('Nie można wyszukiwać danych'),
                                searchPlaceholder: '',
                                statusInitialized: null,
                                statusNoResults: $.i18n('Brak wyników'),
                                statusSearching: $.i18n('Szukam...')
                            },
                            preserveSelectedPosition: 'before'
                        });
                    }
                });
            }
        });
        $(document).selectBind($('body'));
    }

    $(document).on('keydown', function (e) {
        var modal = $('.modal-content:visible');
        if (modal.length) {
            if (e.which === 13) {
                var submit = modal.find('.modal-footer button[type=submit]');
                if (submit.length) {
                    submit.click();
                } else {
                    var a = modal.find('.modal-footer a');
                    if (a.length) {
                        location.href = a.attr('href');
                    } else {
                        var button = modal.find('.modal-footer button[type=button]:visible');
                        if (button.length) {
                            button.click();
                        }
                    }
                }
            }
        }
    });

    // var passwordHint = {
    //     eye: $('<span>').addClass('fas fa-eye-slash'),
    //     init: function () {
    //         var self = this;
    //         $('input[type=password]').each(function () {
    //             var input = $(this).clone();
    //             var eye = self.eye.clone();
    //             var wrapper = $('<div>').addClass('eye');
    //             wrapper.append(input).append(eye);
    //             $(this).replaceWith(wrapper);
    //             eye.on('click', function () {
    //                 if (eye.hasClass('fa-eye')) {
    //                     eye.addClass('fa-eye-slash');
    //                     eye.removeClass('fa-eye');
    //                     input.prop('type', 'password');
    //                 } else {
    //                     eye.addClass('fa-eye');
    //                     eye.removeClass('fa-eye-slash');
    //                     input.prop('type', 'text');
    //                 }
    //             })
    //         });
    //
    //     }
    // }.init();

    $('.pagination .inactive').on('click', function (event) {
        event.preventDefault();
    });

    $(document).on('click', 'table.table-sortable *[data-toggle=sort]', function () {
        var table = $(this).parents('table.table-sortable');

        var requestedOrder = $(this).data('column-order-id');
        var currentOrder = $(table).data('column-order-id');

        if (requestedOrder === currentOrder) {
            requestedOrder = -requestedOrder;
        }

        $(table).find('a[data-toggle=sort]').find('span').remove();

        if (requestedOrder > 0) {
            $(this).append('<span class="fas fa-fw fa-arrow-up"></span>');
        } else {
            $(this).append('<span class="fas fa-fw fa-arrow-down"></span>');

        }

        var rows = Array.from(table.find('tbody tr'));
        var qs = '*:nth-child(' + Math.abs(requestedOrder) + ')';

        rows.sort(function (r1, r2) {
            var t1 = r1.querySelector(qs);
            var t2 = r2.querySelector(qs);

            var v1 = t1.textContent;
            var v2 = t2.textContent;

            if (v1.length && !isNaN(v1)) {
                v1 = parseFloat(v1);
            }

            if (v2.length && !isNaN(v2)) {
                v2 = parseFloat(v2);
                oki
            }

            var sign = requestedOrder > 0 ? 1 : -1;
            return (v1 < v2) ? -sign : (v1 > v2) ? sign : 0;
        });

        rows.forEach(function (row) {
            table.append(row)
        });

        $(table).data('column-order-id', requestedOrder);
    });

    $(window).trigger('resize');

    $('.checkbox-ng, .checkbox-ng label').on('click', function (e) {
        e.preventDefault();

        if ($(this).hasClass('checked')) {
            $(this).removeClass('checked');
            $(this).find('input').prop("checked", false);
        } else {
            $(this).addClass('checked');
            $(this).find('input').prop('checked', true);
        }
    })

    $(".work-distance").ionRangeSlider({
        min: 1,
        max: 100,
        step: 1,
        hide_min_max: true,
        postfix: ' km'
    });

    $(".years-of-work").ionRangeSlider({
        min: 0,
        max: 50,
        step: 1,
        hide_min_max: true,
        postfix: ' years'
    });

    $(".salary-level").ionRangeSlider({
        min: 0,
        max: 50,
        step: 5,
        hide_min_max: true,
        prefix: '£',
        postfix: '/hour'
    });

    $('input[name="register[target]"]').on('change', function () {
        $(this).parents('form').attr('action', $(this).data('path'));
    })

    $('.campaign-comment label').on('click', function(e) {
        $(this).siblings('div').slideToggle(200);
    })

});